import { render, staticRenderFns } from "./Optativa.vue?vue&type=template&id=025a0282"
import script from "./Optativa.vue?vue&type=script&lang=js"
export * from "./Optativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports